import { render, staticRenderFns } from "./afm-rules-container.vue?vue&type=template&id=f4486fe8&scoped=true&"
import script from "./afm-rules-container.vue?vue&type=script&lang=js&"
export * from "./afm-rules-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4486fe8",
  null
  
)

export default component.exports